import './Utilities.css';
import React, { useState, useEffect } from 'react';
import { Button, Input, Layout, Form, message, Row, Modal, Select } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import SideNavBar from "../../Components/SideBar/Sidebar";
import Navbar from "../../Components/Support/Header";
import CredentialsUpdate from "../../Components/CredentialsUpdate/CredentialUpdate";
import PaychexCompare from '../../Components/PaychexCompare/PaychexCompare';
import { Redirect, Link } from "react-router-dom";
import Cookies from "js-cookie";
import axios from "axios";
import { useLocation } from "react-router-dom";
import UnmatchedList from '../../Components/UnmatchedList/UnmatchedList';
import ActiveListUpload from '../../Components/ActiveListUpload/ActiveListUpload';
import TerminationDateUpdate from '../../Components/TermDateUpdate/TermDateUpdate';
const { Header, Content } = Layout;

const Utilities = () => {
    const location = useLocation();
    const { redirectedUrl } = location.state ? location.state : "noUrl";
    const jwtToken = Cookies.get("jwt_token");
    const [openHM, setopenHM] = useState(false);
    const [componentDisabled, setComponentDisabled] = useState(true);
    const [insertDisabled, setInsertDisabled] = useState(false);
    const [updateloading, setUpdateLoading] = useState(false);
    const [searchloading, setSearchLoading] = useState(false);
    const [loading, setLoading] = useState(false);
    const [dataloading, setDataLoading] = useState(false);

    const [lookupClientdata, getLookUpClientData] = useState({});
    const [clientdata, getClientData] = useState([])
    const [clientname, setClientName] = useState('')

    const initialFormData = {
        client_Type: '',
        client: '',
        payroll_Name: '',
        weekend: '',
        rt: '',
        ot: '',
        dt: '',
        status: '',
        other_Hours: '',
        headersrow: '',
        rowstart: '',
        lastrowrowcntdiff: '',
    };
    const [lookupdata, setLookupClientdata] = useState({ ...initialFormData });
    const [formErrors, setFormErrors] = useState({});

    const handleInputChange = (event, field) => {
        const { value } = event.target;
        getLookUpClientData((prevData) => ({
            ...prevData,
            [field]: value,
        }));
        setLookupClientdata({ ...lookupdata, [field]: event.target.value });
        if (formErrors[field]) {
            setFormErrors(prevErrors => ({ ...prevErrors, [field]: '' }));
        }

    };
    const validateForm = () => {
        let errors = {};
        // Check each field for null or empty value
        if (!lookupdata.client_Type.trim()) errors.client_Type = 'Client Type is required';
        if (!lookupdata.client.trim()) errors.client = 'Client is required';
        if (!lookupdata.payroll_Name.trim()) errors.payroll_Name = 'Payroll Name is required';
        if (!lookupdata.weekend.trim()) errors.weekend = 'Weekend is required';
        if (!lookupdata.rt.trim()) errors.rt = 'RT is required';
        if (!lookupdata.ot.trim()) errors.ot = 'OT is required';
        if (!lookupdata.dt.trim()) errors.dt = 'DT is required';
        if (!lookupdata.status.trim()) errors.status = 'Status is required';
        if (!lookupdata.other_Hours.trim()) errors.other_Hours = 'Other Hours is required';
        if (!lookupdata.headersrow.trim()) errors.headersrow = 'Headers Row is required';
        if (!lookupdata.rowstart.trim()) errors.rowstart = 'Row Start is required';
        if (!lookupdata.lastrowrowcntdiff.trim()) errors.lastrowrowcntdiff = 'LotalRowCount - LastRow is required';
        setFormErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const allClients = () => {
        axios({
            url:
                `${process.env.REACT_APP_BASE_URL}MasterLookupTable/GetAllClients`,
            method: "GET",
            headers: {
                "content-type": "application/json",
                Authorization: `Bearer ${jwtToken}`,
            },
        })
            .then((resp) => getClientData(resp.data))
    }
    useEffect(() => {
        allClients();
    }, []);

    const handleSearch = (newValue) => {
        fetch(newValue, clientdata);
    };

    const clientDetails = async (newClient) => {
        setFormErrors({})
        try {
            setSearchLoading(true);
            const res = await
                axios({
                    url:
                        `${process.env.REACT_APP_BASE_URL}MasterLookupTable/GetClientdata?clientname=` +
                        encodeURIComponent(newClient),
                    method: "GET",
                    headers: {
                        "content-type": "application/json",
                        Authorization: `Bearer ${jwtToken}`,
                    },
                })
            let temp = res.data
            if (temp.length === 0) {
                message.warning("No such client")
                setComponentDisabled(true)
                setClientName([]);
                getLookUpClientData([]);
                setInsertDisabled(true)
            }
            else {
                getLookUpClientData(temp)
                setComponentDisabled(false)
                setInsertDisabled(true)
            }
            setSearchLoading(false);
        }
        catch (error) {
            setSearchLoading(false);
            message.error("Unable to get details.")
        }
    };

    const handleUpdate = async () => {

        const url = `${process.env.REACT_APP_BASE_URL}MasterLookupTable/UpdatenewData?clientname=` +
            encodeURIComponent(clientname);
        const config = {
            headers: {
                "content-type": "application/json",
                Authorization: `Bearer ${jwtToken}`,
            },
        };
        try {
            setUpdateLoading(true);
            setDataLoading(true)
            const res =
                await
                    axios.put(url, JSON.stringify(lookupClientdata), config).then((response) => {
                        message.success(`Updated successfully.`);
                        setUpdateLoading(false)
                        //clientDetails();
                        setDataLoading(false)
                        allClients();
                    });

        }
        catch (error) {
            message.error("Try again...")
            setComponentDisabled(true)
            setUpdateLoading(false)
            setDataLoading(false)
            allClients();
        }
    };

    const handleInsertNewRow = async () => {
        // event.preventDefault();
        if (validateForm()) {
            const url = `${process.env.REACT_APP_BASE_URL}MasterLookupTable/InsertnewData`;
            const config = {
                headers: {
                    "content-type": "application/json",
                    Authorization: `Bearer ${jwtToken}`,
                },
            };
            try {
                setComponentDisabled(true)
                setLoading(true);
                const res =
                    await
                        axios.post(url, JSON.stringify(lookupClientdata), config).then((response) => {
                            message.success(`Inserted new client successfully.`);
                            setClientName([])
                            getLookUpClientData([])
                            setLoading(false);
                            allClients();
                        });
            }
            catch (error) {
                setLoading(false);
                message.error("Try again...")
                allClients();
            }
        }
        else {
            message.warning('Please enter all the fields.');
        }
    };

    const showModalForHM = () => {
        setopenHM(true);
    };

    const handleCancelforHM = () => {
        setopenHM(false);
        setClientName([])
        getLookUpClientData([]);
        setComponentDisabled(true)
        setInsertDisabled(false)
        setLookupClientdata({ ...initialFormData });
        setFormErrors({})
    }
    const onClickAnalytics = () => {
        window.location.href = "/analytics"
    }

    if (jwtToken === undefined) {
        return <Redirect to="/" />;
    }

    return (
        <>
            <Layout style={{ backgroundColor: "white", height: "100vh", display: "flex", overflow: "hidden" }} >
                <SideNavBar />
                <Layout className="whole-div">
                    <Header className="timecards-header">
                        <Navbar />
                    </Header>
                    <Content >
                        <div className='headerlookup-div'>
                            <div className="utilities-footer-buttons">
                                <ActiveListUpload redirect={redirectedUrl} />
                                {/* <CredentialsUpdate /> */}
                                <button className="utilities-foo-button" onClick={showModalForHM}>Headers Mapping</button>
                                <Modal
                                    open={openHM}
                                    onCancel={handleCancelforHM}
                                    width={700}
                                    height={300}
                                    footer={[

                                    ]}
                                >
                                    <div className='headerlookup-div'>

                                        <div className='clientname-div'>
                                            <Select
                                                className='input-field'
                                                placeholder="Client Name"
                                                style={{ width: 150 }}
                                                size="middle"
                                                showSearch
                                                showArrow={false}
                                                clearIcon
                                                filterOption={(input, option) =>
                                                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                                }
                                                onSearch={handleSearch}
                                                onChange={(newClient) => {
                                                    clientDetails(newClient)
                                                    setClientName(newClient)
                                                }}
                                                value={clientname}
                                                notFoundContent={"No such Client"}
                                                options={clientdata.map((client) => ({
                                                    label: client,
                                                    value: client,
                                                }))}
                                            />


                                        </div>

                                        <div className='content-div'>
                                            <div className={dataloading ? 'blur' : ''}>
                                                <Form layout="vertical">
                                                    <Row >
                                                        <Form.Item className='form-item' label="Client Type:" validateStatus={formErrors.client_Type && 'error'} help={formErrors.client_Type}>
                                                            <Input placeholder='Client_Type'
                                                                onChange={(event) => handleInputChange(event, 'client_Type')} value={lookupClientdata.client_Type}></Input>
                                                        </Form.Item>
                                                        <Form.Item className='form-item' label="Client:" validateStatus={formErrors.client && 'error'} help={formErrors.client}>
                                                            <Input placeholder='Client'
                                                                onChange={(event) => handleInputChange(event, 'client')} value={lookupClientdata.client}></Input>

                                                        </Form.Item>

                                                        <Form.Item className='form-item' label="Payroll Name:" validateStatus={formErrors.payroll_Name && 'error'} help={formErrors.payroll_Name}>
                                                            <Input placeholder='Payroll_Name'
                                                                onChange={(event) => handleInputChange(event, 'payroll_Name')} value={lookupClientdata.payroll_Name}></Input>
                                                        </Form.Item>
                                                        <Form.Item className='form-item' label="Weekend:" validateStatus={formErrors.weekend && 'error'} help={formErrors.weekend}>
                                                            <Input placeholder='Weekend'
                                                                onChange={(event) => handleInputChange(event, 'weekend')} value={lookupClientdata.weekend}></Input>
                                                        </Form.Item>
                                                        <Form.Item className='form-item' label="RT:" validateStatus={formErrors.rt && 'error'} help={formErrors.rt}>
                                                            <Input placeholder='RT'
                                                                onChange={(event) => handleInputChange(event, 'rt')} value={lookupClientdata.rt}></Input>
                                                        </Form.Item>
                                                        <Form.Item className='form-item' label="OT:" validateStatus={formErrors.ot && 'error'} help={formErrors.ot}>
                                                            <Input placeholder='OT'
                                                                onChange={(event) => handleInputChange(event, 'ot')} value={lookupClientdata.ot}></Input>
                                                        </Form.Item>
                                                        <Form.Item className='form-item' label="DT:" validateStatus={formErrors.dt && 'error'} help={formErrors.dt}>
                                                            <Input placeholder='DT'
                                                                onChange={(event) => handleInputChange(event, 'dt')} value={lookupClientdata.dt}></Input>
                                                        </Form.Item>
                                                        <Form.Item className='form-item' label="Status:" validateStatus={formErrors.status && 'error'} help={formErrors.status}>
                                                            <Input placeholder='Status'
                                                                onChange={(event) => handleInputChange(event, 'status')} value={lookupClientdata.status}></Input>
                                                        </Form.Item>
                                                        <Form.Item className='form-item' label="Other Hours:" validateStatus={formErrors.other_Hours && 'error'} help={formErrors.other_Hours}>
                                                            <Input placeholder='Other_Hours'
                                                                onChange={(event) => handleInputChange(event, 'other_Hours')} value={lookupClientdata.other_Hours}></Input>
                                                        </Form.Item>
                                                        <Form.Item className='form-item' label="Headers Row:" validateStatus={formErrors.headersrow && 'error'} help={formErrors.headersrow}>
                                                            <Input placeholder='Headersrow' onChange={(event) => handleInputChange(event, 'headersrow')} value={lookupClientdata.headersrow} />
                                                        </Form.Item>
                                                        <Form.Item className='form-item' label="Row Start:" validateStatus={formErrors.rowstart && 'error'} help={formErrors.rowstart}>
                                                            <Input placeholder='Rowstart' onChange={(event) => handleInputChange(event, 'rowstart')} value={lookupClientdata.rowstart} />
                                                        </Form.Item>
                                                        <Form.Item className='form-item' label="TotalRowCount - LastRow:" validateStatus={formErrors.lastrowrowcntdiff && 'error'} help={formErrors.lastrowrowcntdiff}>
                                                            <Input placeholder='Lastrowrowcntdiff'
                                                                onChange={(event) => handleInputChange(event, 'lastrowrowcntdiff')}
                                                                value={lookupClientdata.lastrowrowcntdiff} />
                                                        </Form.Item>
                                                    </Row>

                                                </Form>
                                            </div>
                                        </div>
                                        <div className='update-div'>
                                            <Button className='search-button' loading={updateloading} disabled={componentDisabled} onClick={handleUpdate}>
                                                Update
                                            </Button>
                                            <Button className='search-button' loading={loading} disabled={insertDisabled} onClick={() => handleInsertNewRow()} >
                                                Insert
                                            </Button>
                                        </div>
                                    </div>
                                </Modal>
                                {/* <PaychexCompare /> */}
                                <TerminationDateUpdate />
                                <Button className="utilities-foo-button" onClick={onClickAnalytics}>Analytics</Button>

                                <Link to={{ pathname: "/activitylog" }} className='activitylog-button'>Activity log</Link>
                            </div>
                            {/* <div style={{marginTop: "2%"}}>
                                <UnmatchedList />
                            </div> */}

                        </div>
                    </Content>
                </Layout>
            </Layout>
        </>
    )
}
export default Utilities;